// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f1TK2","question":"styles_question__qpgi9","description":"styles_description__3I0sS"};